/**
 * Color palette for ProseMirror rich text editor
 *
 * 33 colors
 * Grayscale first, then organized dark to light
 */
export const COLOR_PALETTE = [
  "#FFFFFF", // Gray
  "#BBBBBB", // Gray
  "#878787", // Gray
  "#444444", // Gray
  "#000000", // Gray
  "#663D0D", // Orange
  "#5C1407", // Red
  "#A12A14", // Red
  "#B26C1E", // Orange
  "#3F4F00", // Green
  "#5F7400", // Green
  "#002967", // Blue
  "#402966", // Purple
  "#E84121", // Red
  "#F06665", // Red
  "#F9992E", // Orange
  "#FDC166", // Orange
  "#FFDB4D", // Yellow
  "#8EA604", // Green
  "#B1B229", // Yellow
  "#CDD87A", // Green
  "#0048B2", // Blue
  "#0066CC", // Blue
  "#67A3DF", // Blue
  "#6F4DB3", // Purple
  "#A06FFB", // Purple
  "#C284FB", // Purple
  "#F9CBCB", // Red
  "#FFEBCB", // Orange
  "#FFF1B9", // Yellow
  "#F2F6D8", // Green
  "#CBE1F6", // Blue
  "#EBD5FD", // Purple
];
